import safeTradeController from './safeTradeReactController.jsx';

export default {
    dependencies: ['$element'],
    callable(root) {
        safeTradeController(root);
    },
};



// WEBPACK FOOTER //
// ./safeTrade/safeTradeController.js